import React, { useState, useRef, useEffect } from "react";
import Select, { components } from "react-select";
import classes from "../ServicesTable.module.scss"
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import { E2Data } from "../../../lib/ddd/ddd";
import { useQuery } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import Workflow from "./Workflow";

const EU_Units = new E2Data("EU_Units");
EU_Units.format = "full";

const TextInputWithDropdown = ({ orgData, deviceData, stepData, items}) => {
    const [inputValue, setInputValue] = useState();
    const [inputSelected, setInputSelected] = useState();
    const [isDropdownVisible, setIsDropdownVisible] = useState(false);
    const [instructions, setInstructions] = useState(null);
    const [mainWorkflow, setMainWorkflow] = useState(null);
    const dropdownRef = useRef(null);
    const buttonRef = useRef(null);
    const {t} = useTranslation();

    const {isPending, data:unitData, refetch} = useQuery({
        queryKey: ['Data.GetEntityData', EU_Units.GetParamsObject()],
        queryFn: () => EU_Units.GetData()
    })

    const handleItemSelect = (item) => {
        setInputValue("");
        setInputSelected(item);
        setIsDropdownVisible(false);
    };

    const onInputChange = (value) => {
        setInputSelected(null);
        setInputValue(value)
    };

    useEffect(() => {
        const handleClickOutside = (e) => {
          if (
            dropdownRef.current && !dropdownRef.current.contains(e.target) &&
            buttonRef.current && !buttonRef.current.contains(e.target)
          ) {
            setIsDropdownVisible(false);
          }
        };
        document.addEventListener("click", handleClickOutside);
        return () => {
          document.removeEventListener("click", handleClickOutside);
        };
    }, []);

    useEffect(() => {
        
    },[deviceData]);

    useEffect(() => {
    }, [orgData]);

    useEffect(() => {
        if(!stepData) return setInstructions(null);
        if(stepData?.ServiceEndPointCode__AdditionalUIRules){
            try{
                const instructions = JSON.parse(stepData?.ServiceEndPointCode__AdditionalUIRules);
                setInstructions(instructions);
            }catch(e){}
        }
    }, [stepData]);

    const onCreateNewClick = () => {

    }

    return (
        <div className={`${classes["dropdown-container"]}`}>
            <input
                type="text"
                value={inputValue}
                onChange={(e) => onInputChange(e.target.value)}
                placeholder={inputSelected ? t("Selected")+": ["+inputSelected.NameUnit+"]" : t("Type or select an option...")}
                className={inputSelected ? `${classes["dropdown-text-field-selected"]}` : `${classes["dropdown-text-field"]}`}
                style={instructions?.OrgUnitId ? {borderRadius: "8px 0px 0px 8px"} : {borderRadius: "8px"}}
            />

            {instructions?.OrgUnitId && <button ref={buttonRef} onClick={() => setIsDropdownVisible((prev) => !prev)} className={`${classes["dropdown-button"]}`}>
                <ArrowDropDownIcon className="mb-5"/>
            </button>}

            {isDropdownVisible && (
                <div className={`${classes["dropdown"]}`} ref={dropdownRef}>
                    <div key={-1} className={`${classes["dropdown-item"]}`}  onClick={onCreateNewClick}>
                        {t("Create new unit")}
                    </div>  
                {unitData?.result?.data?.map((item, index) => (
                    <div key={index} className={`${classes["dropdown-item"]}`}  onClick={() => handleItemSelect(item)}>
                    {item?.NameUnit}
                    </div>
                ))}
                </div>
            )}
            <Workflow orgData={orgData} deviceData={deviceData} stepData={stepData} workflow={aa.FiscUnitRegCodeDef.OrgUnitId.workflow} value={inputValue}/>
        </div>
  );
};

export default TextInputWithDropdown;


const aa = {
    "FiscUnitRegCodeDef": {
        "type" : "text", 
        "required": false,
        "editable": true,   //če je tole false, potem imajo samo select opcijo, če je vpisan OrgUnitId
        "instructions": "https://miniblagajna.fu.gov.si",
        "instructionsText": "Vpiše se oznaka poslovnega prostora, v katerem zavezanec izdaja račune pri gotovinskem poslovanju in je bila predhodno registrirana na davčnem portalu za potrebe fiskalizacije. Več na https://www.fu.gov.si/fileadmin/Internet/Nadzor/Podrocja/Davcne_blagajne_in_VKR/Opis/Davcne_blagajne_in_davcno_potrjevanje_racunov.docx",
        "OrgUnitId" : {//specifike connectiona. Če ni možen connection, ga ni noter
            "workflow" : [  //workflow lahko zahteva manual executeion ali ne. Če daš "button" param noter, potem 
            {
                "name" : "unique-name",
                "type" : "table",
                "table" : "EU_Units",
                "fields" : {
                    "FiscUnitRegCode": {
                        "required": true,
                        "editable": true,
                        "Title": "Oznaka poslovnega prostora",
                        "Tooltip": "Vpiše se oznaka poslovnega prostora, v katerem zavezanec izdaja račune pri gotovinskem poslovanju.Oznaka je lahko sestavljena iz številk in črk 0-9, a-z, A-Z.Oznaka mora biti enaka kot tista, ki je navedena na računih. Oznaka je enkratna na nivoju zavezanca.",
                        "minlength": 1,
                        "maxlength": 20,
                        "example": "LK1",
                        "default" : "<!--aorg.Id-->",
                        "init": null
                    }
                }, //list of fields displayed
                "execute" : {"method" : "Data.Create", "params" : {"values" : {}}} //vsa field polja bodo avtomatsko dodana v values tudi
            },
            {
                "type" : "extension",
                "fields" : null,
                "execute" : {"method" : "EUeInvoices.RegisterBusinessPremise", "button" : "Register", "params" : {"Mode": "PROD", "UnitId" : "<!--workflow.unique-name.response.values.0.id-->", "UnitRegCode" : "<!--workflow.unique-name.fields.FiscUnitRegCode.value-->"}}
            },
            {
                "type" : "ui",
                "action" : "reloadData"     //refreshes the device data on display, in case anything is changed by extensions for example
            },
            {
                "name" : "unique-name",
                "type" : "table",
                "table" : "EU_Units",
                "fields" : {
                    "FiscUnitRegCode": {
                        "required": true,
                        "editable": true,
                        "Title": "yolo",
                        "Tooltip": "Vpiše se oznaka poslovnega prostora, v katerem zavezanec izdaja račune pri gotovinskem poslovanju.Oznaka je lahko sestavljena iz številk in črk 0-9, a-z, A-Z.Oznaka mora biti enaka kot tista, ki je navedena na računih. Oznaka je enkratna na nivoju zavezanca.",
                        "minlength": 1,
                        "maxlength": 20,
                        "example": "LK1",
                        "default" : "<!--aorg.Id-->",
                        "init": null
                    }
                }, //list of fields displayed
                "execute" : {"method" : "Data.Create", "params" : {"values" : {}}} //vsa field polja bodo avtomatsko dodana v values tudi
            },
            {
                "type" : "extension",
                "fields" : null,
                "execute" : {"method" : "EUeInvoices.RegisterBusinessPremise", "button" : "Finish", "params" : {"Mode": "PROD", "UnitId" : "<!--workflow.unique-name.response.values.0.id-->", "UnitRegCode" : "<!--workflow.unique-name.fields.FiscUnitRegCode.value-->"}}
            },
            {
                "type" : "ui",
                "action" : "setvalue",
                "value" : "<!--workflow.unique-name.response.values.0.id-->"
            }]
        }
    }
}